export class Rating {
	Rating: number;
	Text: string;

	constructor() {
		this.Rating = 0;
		this.Text = '';
	}
}